import { AddCircle } from './AddCircle';
import { Api } from './Api';
import { ArrowDown } from './ArrowDown';
import { ArrowLeft } from './ArrowLeft';
import { ArrowRight } from './ArrowRight';
import { ArrowRightOutline } from './ArrowRightOutline';
import { ArrowUp } from './ArrowUp';
import { Backet } from './Backet';
import { Bell } from './Bell';
import { Box } from './Box';
import { Calendar } from './Calendar';
import { CalendarViewDay } from './CalendarViewDay';
import { Camera } from './Camera';
import { Change } from './Change';
import { Chat } from './Chat';
import { CheckCircle } from './checkCircle';
import { CheckboxOff } from './CheckboxOff';
import { CheckboxOn } from './CheckboxOn';
import { ChevronDown } from './ChevronDown';
import { ChevronLeft } from './ChevronLeft';
import { ChevronRight } from './ChevronRight';
import { ChevronUp } from './ChevronUp';
import { Close } from './Close';
import { Confirm } from './Confirm';
import { ConfirmFill } from './ConfirmFill';
import { Copy } from './Copy';
import { Decline } from './Decline';
import { Delayed } from './Delayed';
import { Disable } from './Disable';
import { Document } from './Document';
import { Download } from './Download';
import { DownloadList } from './DownloadList';
import { Edit } from './Edit';
import { Energy } from './Energy';
import { Exclamation } from './Exclamation';
import { ExclamationMark } from './ExclamationMark';
import { Export } from './Export';
import { External } from './External';
import { Extraction } from './Extraction';
import { EyeClose } from './EyeClose';
import { EyeOpen } from './EyeOpen';
import { File } from './File';
import { Filter } from './Filter';
import { Generate } from './Generate';
import { HealthCare } from './HealthCare';
import { Help } from './Help';
import { Home } from './Home';
import { Immunity } from './Immunity';
import { Key } from './Key';
import { Laboratory } from './Laboratory';
import { LeftArrow } from './LeftArrow';
import { List } from './List';
import { ListFilter } from './ListFilter';
import { Loader } from './Loader';
import { Lock } from './Lock';
import { LogoLilac } from './LogoLilac';
import { Logout } from './Logout';
import { Mail } from './Mail';
import { Mind } from './Mind';
import { Minus } from './Minus';
import { Mobile } from './Mobile';
import { MoreVertical } from './MoreVertical';
import { NormalSample } from './NormalSample';
import { Outside } from './Outside';
import { Pen } from './Pen';
import { PieChart } from './PieChart';
import { Plane } from './Plane';
import { Print } from './Print';
import { Project } from './Project';
import { PromoCode } from './PromoCode';
import { Publish } from './Publish';
import { QR } from './QR';
import { Question } from './Question';
import { QueuedSample } from './QueuedSample';
import { RadioOff } from './RadioOff';
import { RadioOn } from './RadioOn';
import { Refresh } from './Refresh';
import { SampleAdn } from './SampleAdn';
import { SampleKit } from './SampleKit';
import { Search } from './Search';
import { Sequencing } from './Sequencing';
import { Share } from './Share';
import { SortAZ } from './SortAZ';
import { SortLatest } from './SortLatest';
import { SortOldest } from './SortOldest';
import { SortZA } from './SortZA';
import { Speedometer } from './Speedometer';
import { StarFilled } from './StarFilled';
import { Strength } from './Strength';
import { Supplement } from './Supplement';
import { Survey } from './Survey';
import { Tasks } from './Tasks';
import { Thunder } from './Thunder';
import { Time } from './Time';
import { Trash } from './Trash';
import { TurnOff } from './TurnOff';
import { UserGroup } from './UserGroup';
import { UserOutlined } from './UserOutlined';
import { WellBeing } from './WellBeing';
import { Check } from './check';
import { EditDraft } from './EditDraft';
import { Play } from './Play';
import { Invoice } from './Invoice';
import { Alert } from './Alert';
import { GridLayout } from './GridLayout';
import { UserManagement } from './UserManagement';
import { CustomerGroup } from './CustomerGroup';
import { Folder } from './Folder';
import { ShoppingCard } from './ShoppingCard';
import { Package } from './Package';
import { TestTube } from './TestTube';
import { Dna } from './Dna';
import { BarChart } from './BarChart';
import { FileText } from './FileText';
import { MedicalCross } from './MedicalCross';
import { Notebook } from './Notebook';
import { ClipboardChecklist } from './ClipboardChecklist';
import { Inventory } from './Inventory';

export const icons = {
  /* -------------------------------------------------------------------------- */
  /*                                  NEW ICON                                  */
  /* -------------------------------------------------------------------------- */
  alert: Alert,
  gridLayout: GridLayout,
  userManagement: UserManagement,
  customerGroup: CustomerGroup,
  folder: Folder,
  shoppingCard: ShoppingCard,
  package: Package,
  testTube: TestTube,
  dna: Dna,
  barChart: BarChart,
  fileText: FileText,
  medicalCross: MedicalCross,
  notebook: Notebook,
  clipboardChecklist: ClipboardChecklist,
  mail: Mail,
  inventory: Inventory,
  /* -------------------------------------------------------------------------- */
  /*                                  OLD ICON                                  */
  /* -------------------------------------------------------------------------- */
  addCircle: AddCircle,
  api: Api,
  arrowDown: ArrowDown,
  arrowLeft: ArrowLeft,
  arrowRight: ArrowRight,
  arrowRightOutline: ArrowRightOutline,
  arrowUp: ArrowUp,
  backet: Backet,
  bell: Bell,
  editDraft: EditDraft,
  minus: Minus,
  box: Box,
  calendar: Calendar,
  camera: Camera,
  change: Change,
  chat: Chat,
  checkboxOff: CheckboxOff,
  checkboxOn: CheckboxOn,
  chevronDown: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronUp: ChevronUp,
  close: Close,
  confirm: Confirm,
  confirmFill: ConfirmFill,
  copy: Copy,
  decline: Decline,
  disable: Disable,
  document: Document,
  download: Download,
  downloadList: DownloadList,
  edit: Edit,
  energy: Energy,
  exclamation: Exclamation,
  export: Download,
  upload: Export,
  extraction: Extraction,
  eyeClose: EyeClose,
  eyeOpen: EyeOpen,
  file: File,
  play: Play,
  filter: Filter,
  generate: Generate,
  healthCare: HealthCare,
  pieChart: PieChart,
  home: Home,
  help: Help,
  immunity: Immunity,
  key: Key,
  laboratory: Laboratory,
  leftArrow: LeftArrow,
  list: List,
  listFilter: ListFilter,
  loader: Loader,
  lock: Lock,
  logoLilac: LogoLilac,
  logout: Logout,
  mind: Mind,
  moreVertical: MoreVertical,
  normalSample: NormalSample,
  outside: Outside,
  pen: Pen,
  plane: Plane,
  print: Print,
  project: Project,
  publish: Publish,
  qr: QR,
  mobile: Mobile,
  queuedSample: QueuedSample,
  radioOff: RadioOff,
  radioOn: RadioOn,
  refresh: Refresh,
  sampleAdn: SampleAdn,
  sampleKit: SampleKit,
  search: Search,
  sequencing: Sequencing,
  sortAZ: SortAZ,
  sortLatest: SortLatest,
  sortOldest: SortOldest,
  sortZA: SortZA,
  speedometer: Speedometer,
  starFilled: StarFilled,
  strength: Strength,
  supplement: Supplement,
  survey: Survey,
  share: Share,
  tasks: Tasks,
  thunder: Thunder,
  time: Time,
  trash: Trash,
  turnOff: TurnOff,
  userGroup: UserGroup,
  userOutlined: UserOutlined,
  wellBeing: WellBeing,
  checkCircle: CheckCircle,
  check: Check,
  question: Question,
  calendarViewDay: CalendarViewDay,
  delayed: Delayed,
  external: External,
  exclamationMark: ExclamationMark,
  promoCode: PromoCode,
  invoice: Invoice,
};
